export default function Warranty() {
  return (
    <section id="warranty" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 text-orange-600 rounded-full text-sm font-semibold mb-4">
            <i className="ri-shield-check-line"></i>
            GUARANTEED QUALITY
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our Commitment to Excellence
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We stand behind our work with comprehensive warranties and guaranteed quality on every project
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          <div className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-2xl border border-orange-100">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Full Warranty</h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              Comprehensive warranty coverage on all materials and workmanship. Your investment is protected for years to come.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-orange-500 font-bold"></i>
                Material warranty included
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-orange-500 font-bold"></i>
                Workmanship guarantee
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-orange-500 font-bold"></i>
                Long-term protection
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200">
            <div className="w-16 h-16 bg-gray-900 rounded-full flex items-center justify-center mb-6">
              <i className="ri-checkbox-circle-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Guaranteed Work</h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              Every project is completed to the highest standards with attention to detail and quality craftsmanship.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-orange-500 font-bold"></i>
                Quality materials only
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-orange-500 font-bold"></i>
                Expert installation
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-orange-500 font-bold"></i>
                Satisfaction guaranteed
              </li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-2xl border border-orange-100">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6">
              <i className="ri-time-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Fast Service</h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              Quick response times and efficient project completion without compromising on quality or safety.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-orange-500 font-bold"></i>
                Rapid response time
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-orange-500 font-bold"></i>
                Efficient completion
              </li>
              <li className="flex items-center gap-2 text-sm text-gray-700">
                <i className="ri-check-line text-orange-500 font-bold"></i>
                Emergency services available
              </li>
            </ul>
          </div>
        </div>

        {/* Large CTA Section */}
        <div className="relative rounded-3xl overflow-hidden">
          <div className="absolute inset-0 w-full h-full">
            <img
              src="https://public.readdy.ai/ai/img_res/b6e1b877366edda172c7b600b7176bec.jpg"
              alt="Quality Roofing Work"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/80 to-gray-900/90"></div>
          </div>

          <div className="relative z-10 py-20 px-8 text-center">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              🔨 At Sorto's Premier Roofing And Const LLC
            </h2>
            <p className="text-xl text-gray-200 max-w-4xl mx-auto mb-8 leading-relaxed">
              We offer reliable and high quality professional roofing services. We specialize in roof repairs, replacements and inspections to protect your home or business.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-10">
              <div className="flex items-center justify-center gap-3 text-white">
                <i className="ri-check-double-line text-3xl text-orange-500"></i>
                <span className="text-lg font-semibold">Guaranteed Work</span>
              </div>
              <div className="flex items-center justify-center gap-3 text-white">
                <i className="ri-flashlight-line text-3xl text-orange-500"></i>
                <span className="text-lg font-semibold">Fast Service</span>
              </div>
              <div className="flex items-center justify-center gap-3 text-white">
                <i className="ri-user-star-line text-3xl text-orange-500"></i>
                <span className="text-lg font-semibold">Professional Team</span>
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-4">
              <button
                onClick={() => {
                  const element = document.getElementById('contact');
                  element?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                📞 Contact Us Today
              </button>
              <button
                onClick={() => {
                  const element = document.getElementById('free-inspection');
                  element?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="px-8 py-4 bg-white hover:bg-gray-100 text-gray-900 font-bold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                Get Free Estimate
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
